import { render, staticRenderFns } from "./SelfTestPelletizingPelList.vue?vue&type=template&id=9ec2b5b8&"
import script from "./SelfTestPelletizingPelList.vue?vue&type=script&lang=js&"
export * from "./SelfTestPelletizingPelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports